import React from 'react'
import * as R from 'ramda'

import { getDomainStatus } from 'organisms/EmailSetting/utils'
import SurveyEmailSettings from '.'

/**
 *
 * @param {object} props
 * @param {import('.').DomainOption[]} props.domains
 * @param {import('.').Template} props.defaultTemplate
 * @param {import('.').TemplateOption[]} props.templates
 * @param {import('.').TemplateOption[]} props.templates
 * @param {string} props.surveyType
 * @param {function} props.handleSendTestModalOpen
 */
function SurveyEmailSettingsContainer({
  defaultTemplate,
  domains,
  onChange,
  templates,
  surveyType,
  handleSendTestModalOpen,
  isDefaultLanguage,
}) {
  function _getDefaultTemplateWithHTML(defaultTemplate, templates) {
    const next = { ...defaultTemplate }
    next.html = getHTMLFromTemplateID(next.email_template, templates)
    return next
  }

  return (
    <SurveyEmailSettings
      domains={getDomainOption(domains)}
      templates={templates}
      defaultTemplate={_getDefaultTemplateWithHTML(defaultTemplate, templates)}
      surveyType={surveyType}
      onChange={onChange}
      handleSendTestModalOpen={handleSendTestModalOpen}
      isDefaultLanguage={isDefaultLanguage}
    />
  )
}

export default SurveyEmailSettingsContainer

export function getDomainOption(domains) {
  const defaultOption = {
    text: '@simplesat-mail.com',
    value: '@simplesat-mail.com',
    status: 'validated',
  }
  const domainOption = domains
    ? domains.map((item) => ({
        text: `@${item.domain}`,
        value: `@${item.domain}`,
        status: getDomainStatus(item.valid, item.last_validation_attempt_at),
      }))
    : []
  return R.prepend(defaultOption, domainOption)
}

export function getHTMLFromTemplateID(id, templates) {
  return R.compose(R.prop('html'), R.find(R.propEq('id', id)))(templates)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyEmailSettings/container.js